import { Show } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Button } from "@/designSystem/components/button"
import { Text } from "@/designSystem/components/text"
import { useI18nContext } from "@/i18n/i18n-solid"
import { SubscriptionHeader } from "./subscription-header"
import { tierSelectionContainerClass } from "./tier-selection.css"

interface SubscriptionConfirmationProps {
  publicationId: string
  publicationName: string
  publicationLogoUrl?: string | null
  authorName?: string
  onContinue: () => void
}

export function SubscriptionConfirmation(props: SubscriptionConfirmationProps) {
  const { LL } = useI18nContext()

  const titleText = () =>
    props.publicationName
      ? LL().auth.tierSelectionTitleSubscribed({
          publicationName: props.publicationName,
        })
      : LL().auth.tierSelectionTitleSubscribedNoName()

  const descriptionContent = () => (
    <Show
      when={props.authorName}
      fallback={LL().auth.subscriptionConfirmationDescriptionNoAuthor()}
    >
      {LL().auth.subscriptionConfirmationDescriptionBeforeAuthor()}
      <Text fontSize="m" fontWeight="700" color="sand800">
        {props.authorName}
      </Text>
      {LL().auth.subscriptionConfirmationDescriptionAfterAuthor()}
    </Show>
  )

  return (
    <Box
      flexDirection="column"
      gap="32"
      alignItems="center"
      class={tierSelectionContainerClass}
    >
      <Box flexDirection="column" gap="16">
        <SubscriptionHeader
          publicationLogoUrl={props.publicationLogoUrl}
          publicationName={props.publicationName}
          titleText={titleText()}
          descriptionContent={descriptionContent()}
        />
      </Box>
      <Button hue="emerald" onClick={props.onContinue}>
        {LL().onboarding.continue()}
      </Button>
    </Box>
  )
}
